import React from 'react';

import './Pagination.scss';

export class Pagination extends React.Component {
  render() {
    return (
      <div className="pagination-root">
        <div style={{ flex: '1' }}></div>
        <div style={{ display: 'flex', gap: '8px' }}>
          <div className="first-page cursor-pointer" onClick={this.props.handleClickOnFirstPage}></div>
          <div className="prev-page cursor-pointer" onClick={this.props.handleClickOnPreviousPage}></div>
          <div className="page-number">{this.props.pageNumber + '/' + this.props.totalPage}</div>
          <div className="next-page cursor-pointer" onClick={this.props.handleClickOnNextPage}></div>
          <div className="last-page cursor-pointer" onClick={this.props.handleClickOnLastPage}></div>
        </div>
      </div>
    );
  }
}

export default Pagination;
